export var PortalTarget;
(function (PortalTarget) {
    PortalTarget["SIDEBAR"] = "sidebar";
    PortalTarget["SIDE_MENU"] = "side-menu";
    PortalTarget["BOTTOM_NAVIGATION"] = "bottom-navigation";
    PortalTarget["FLOATING_ACTION_BUTTONS"] = "floating-action-buttons";
    PortalTarget["MODAL"] = "modal";
    PortalTarget["MODALS"] = "modals";
    PortalTarget["BRAND_SEARCH_BAR"] = "brand-search-bar";
})(PortalTarget || (PortalTarget = {}));
